import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getPortfolio } from "../../../feature/portfolio/portfolioSlice";
import { getPost } from "../../../feature/posts/postSlice";
import "./dashboard.scss";

import { BsFileEarmarkPost } from "react-icons/bs";
import { RiShieldStarFill } from "react-icons/ri";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { posts, portfolio } = useSelector((state) => state);
  useEffect(() => {
    dispatch(getPost());
    dispatch(getPortfolio());
  }, [dispatch]);

  return (
    <div className="dashboard-container">
      <p className="post">
        <BsFileEarmarkPost className="icon" /> Total Posts:{" "}
        {posts.posts.AllPosts && posts.posts.AllPosts.length}
      </p>
      <p className="portfolio">
        <RiShieldStarFill className="icon" /> Total Portfolio:{" "}
        {portfolio.portfolio.allPortfolio &&
          portfolio.portfolio.allPortfolio.length}
      </p>
    </div>
  );
};

export default Dashboard;
